import { ResourceType, ResourceStock, COMMON_RESOURCES, RESOURCE_INFO } from '../systems/ResourceManager';

// === UTILITAIRE DE LOOT RESSOURCES ===
// Génère des drops de ressources selon le contexte (combat, exploration, events).

/** Tire une ressource commune aléatoire */
function randomCommon(): ResourceType {
  return COMMON_RESOURCES[Math.floor(Math.random() * COMMON_RESOURCES.length)];
}

/** Génère un drop de ressources pour un combat normal (1-3 communes) */
export function rollCombatNormalResources(): Partial<ResourceStock> {
  const result: Partial<ResourceStock> = {};
  const count = 1 + Math.floor(Math.random() * 3); // 1-3
  for (let i = 0; i < count; i++) {
    const type = randomCommon();
    result[type] = (result[type] ?? 0) + 1;
  }
  return result;
}

/** Génère un drop de ressources pour un combat élite (3-5 + 30% cristal) */
export function rollCombatEliteResources(): Partial<ResourceStock> {
  const result: Partial<ResourceStock> = {};
  const count = 3 + Math.floor(Math.random() * 3); // 3-5
  for (let i = 0; i < count; i++) {
    const type = randomCommon();
    result[type] = (result[type] ?? 0) + 1;
  }
  if (Math.random() < 0.3) {
    result.crystal = (result.crystal ?? 0) + 1;
  }
  return result;
}

/** Génère un drop de ressources pour un boss (4-7 + 1-2 cristal + 35% os maudit) */
export function rollCombatBossResources(): Partial<ResourceStock> {
  const result: Partial<ResourceStock> = {};
  const count = 4 + Math.floor(Math.random() * 4); // 4-7
  for (let i = 0; i < count; i++) {
    const type = randomCommon();
    result[type] = (result[type] ?? 0) + 1;
  }
  result.crystal = (result.crystal ?? 0) + 1 + (Math.random() < 0.4 ? 1 : 0);
  if (Math.random() < 0.35) {
    result.cursed_bone = (result.cursed_bone ?? 0) + 1;
  }
  return result;
}

/** Génère un drop de ressources pour l'exploration (1-4 communes) */
export function rollExploreResources(): Partial<ResourceStock> {
  const result: Partial<ResourceStock> = {};
  const count = 1 + Math.floor(Math.random() * 4); // 1-4
  for (let i = 0; i < count; i++) {
    const type = randomCommon();
    result[type] = (result[type] ?? 0) + 1;
  }
  return result;
}

/** Formate un drop de ressources en texte lisible */
export function formatResourceDrop(drop: Partial<ResourceStock>): string {
  const parts: string[] = [];
  for (const [type, amount] of Object.entries(drop)) {
    if (amount && amount > 0) {
      const info = RESOURCE_INFO[type as ResourceType];
      parts.push(`${info.emoji} ${info.name} ×${amount}`);
    }
  }
  return parts.join(' ');
}
